export default __webpack_public_path__ + "static/media/banner.a36ad2d7.png";